<template>
  <lf-button
    data-cy="run-backtest-report-button"
    class="h-10 border border-gray-200 bg-white text-primary hover:bg-gray-100"
    :disabled="!applicationIds.length"
    @click="openEmailModal"
  >
    <slot name="icon">
      <icon-base :icon="IconEmail" view-box="0 0 16 16" class="mr-2 h-4 w-4" />
    </slot>
    {{ t("COMMON.EMAIL") }}
  </lf-button>
  <send-deal-communication-modal
    v-if="showEmailModal"
    :deal-id="applicationIds"
    @close-dialog="showEmailModal = false"
  />
</template>
<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import SendDealCommunicationModal from "@/components/communication/SendDealCommunicationModal.vue";
import IconEmail from "@/components/icons/IconEmail.vue";

interface Props {
  applicationIds: string[];
}

defineProps<Props>();

const { t } = useI18n();

const showEmailModal = ref(false);

const openEmailModal = () => {
  showEmailModal.value = true;
};
</script>
